'use strict';

var aviarySizes = {};

exports.__exports = aviarySizes;
//# sourceMappingURL=aviarySizes.cjs.map
